module.exports = __webpack_public_path__ + "static/media/back.8b2e5e9c.svg";